export enum EFileType {
	SERVER = 'SERVER',
	LOCAL = 'LOCAL',
}

export const FILE_SIZE = 20 * 1024 * 1024; // 10MB in bytes, 10e6

export const AVATAR_ACCEPT =
	'.jpg, .jpeg, .png, .heif, .heic, .notExist, capture=camera';

export const FILE_ACCEPT =
	'.jpg, .jpeg, .png, .heif, .heic, .pdf, capture=camera';

export const FILE_UPLOAD_ACCEPT =
	'.pdf, .jpg, .jpeg, .png, .gif, .zip, .xls, .xlsx, .ppt, .pptx, .doc, .docx, .hwp, capture=camera';

export const EXCEL_ACCEPT = '.xlsx, .xls';

export const IMAGE_TYPE = '.jpg, .jpeg, .png, .heif, .heic';

export const STAMP_ACCEPT = '.png';

export const EDITOR_IMAGE_ACCEPT = '.jpg, .jpeg, .png, .gif';

export const MAX_FILE_UPLOAD = 10;

export const FILE_SIZE_2MB = 2; // 2MB,
export const FILE_SIZE_2MB_BYTE = FILE_SIZE_2MB * 1024 * 1024; // 2MB in bytes, 2e6
export const FILE_SIZE_10MB = 20; // 10MB,
export const FILE_SIZE_10MB_BYTE = FILE_SIZE_10MB * 1024 * 1024; // 10MB in bytes, 10e6
export const FILE_SIZE_20MB = 20; // 20MB,
export const FILE_SIZE_20MB_BYTE = FILE_SIZE_20MB * 1024 * 1024; // 20MB in bytes, 20e6
